module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "25%"
    },
    attrs: {
      "label": "内容类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.contentType),
      callback: function($$v) {
        _vm.contentType = $$v
      },
      expression: "contentType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": '全部',
      "value": ''
    }
  }), _vm._v(" "), _vm._l((_vm.nrModeArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showadd()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.resultObjInfo,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内容类型",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('span', [_vm._v("图片")]) : _vm._e(), _vm._v(" "), (scope.row.type == 2) ? _c('span', [_vm._v("视频")]) : _c('span')]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内容",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.type == 1),
            expression: "scope.row.type == 1"
          }],
          staticClass: "banner_list",
          staticStyle: {
            "height": "36px"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#0099FF"
          },
          on: {
            "click": function($event) {
              return _vm.seebigimg(scope.row.links)
            }
          }
        }, [_vm._v("预览")])]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.type == 2),
            expression: "scope.row.type == 2"
          }],
          staticClass: "banner_list",
          staticStyle: {
            "height": "36px"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#0099FF"
          },
          on: {
            "click": function($event) {
              return _vm.palySeevideo(scope.row.links)
            }
          }
        }, [_vm._v("预览")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "",
      "label": "描述"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.desc))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "添加时间",
      "width": "",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.cTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.editView(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n            ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.deleteShopPage(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\r\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.shopTitle,
      "visible": _vm.dialogVisible,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label-width": "170px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.viewType),
      callback: function($$v) {
        _vm.viewType = $$v
      },
      expression: "viewType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("图片")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("视频")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "auto-complete": "off",
      "maxlength": "20",
      "placeholder": "请输入内容描述最多20个字符"
    },
    model: {
      value: (_vm.viewDesc),
      callback: function($$v) {
        _vm.viewDesc = $$v
      },
      expression: "viewDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewType == 1),
      expression: "viewType == 1"
    }],
    attrs: {
      "label": "上传：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('div', {
    staticClass: "upload",
    staticStyle: {
      "display": "flex"
    }
  }, [_vm._l((_vm.imgarr), function(link, i) {
    return _c('div', {
      key: i,
      staticStyle: {
        "display": "inline",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "position": "relative"
      }
    }, [_c('img', {
      staticClass: "chahao",
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteimg(i, link)
        }
      }
    }), _vm._v(" "), (link) ? _c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": link.indexOf(_vm.baseOssUrl) != -1 ? link : _vm.baseOssUrl + link,
        "fit": "cover"
      }
    }) : _c('i', {
      staticClass: "el-icon-plus avatar-uploader-icon",
      staticStyle: {
        "width": "80px"
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "upload",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "disabled": !_vm.isdisabled,
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageUrl2) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.imageUrl2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    staticStyle: {
      "width": "80px"
    }
  })])], 1)], 2), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center",
      "color": "#ff8083",
      "vertical-align": "bottom"
    }
  }, [_vm._v("最多上传5张 (支持JPG  PNG 格式)，单张图片大小不超过5MB")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewType == 2),
      expression: "viewType == 2"
    }],
    attrs: {
      "label": "视频：",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo()
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footSuspension",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.endAdd()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))])], 1)], 1)]), _vm._v(" "), (_vm.isShowImageDialog) ? _c('div', {
    staticClass: "fullscreenMask",
    on: {
      "click": _vm.clearImg
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-close",
    staticStyle: {
      "position": "absolute",
      "top": "50px",
      "right": "50px",
      "font-size": "30px",
      "cursor": "pointer"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "800px",
      "margin": "200px 0 0 30%"
    }
  }, [_c('el-carousel', {
    attrs: {
      "autoplay": false,
      "height": "500px"
    }
  }, _vm._l((_vm.ShowImageDialogImgarr), function(item, index) {
    return _c('el-carousel-item', {
      key: index,
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%",
        "max-height": "100%"
      },
      attrs: {
        "src": _vm.baseOssUrl + _vm.ShowImageDialogImgarr[index]
      }
    })])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "120px 0 30px 0"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("店铺视图")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-100a75a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/ShopPage.vue
// module id = 1634
// module chunks = 3